import { queryOptions } from '@tanstack/react-query';
import { getVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getVehicleInformationFunction';
import { getVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getVehicleInformation.type';
import { getInitialVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getInitialVehicleInformationFunction';

export const getVehicleInformationOption = ({
  id,
  damaged_id,
  type,
}: getVehicleInformationType) =>
  queryOptions({
    queryKey: [id, damaged_id, type],
    queryFn: () => {
      if (type === 'initial') {
        return getInitialVehicleInformationFunction({ id, damaged_id, type });
      }
      return getVehicleInformationFunction({ id, damaged_id, type });
    },
  });
